import { motion } from "framer-motion";

import { getTileSize } from "../utils/tileSize";

export default function FacilityTile({ facility, onClick }) {

    const { colSpan, rowSpan } = getTileSize(
        facility.current_vehicles || 0
    );

    return (

        <motion.div
            layout
            whileHover={{
                scale: 1.02
            }}
            transition={{
                type: "spring",
                stiffness: 120,
                damping: 18
            }}
            onClick={() => onClick(facility)}
            className={`
                h-full

                bg-white
                rounded-2xl
                shadow-sm
                border
                border-gray-200

                hover:shadow-lg
                transition-all
                duration-300

                cursor-pointer

                overflow-hidden

                p-4

                flex
                flex-col
                justify-between

                col-span-${colSpan}
                row-span-${rowSpan}
            `}
        >

            {/* TOP */}

            <div>

                <h2 className="
                    text-lg
                    font-bold
                    text-gray-800
                    leading-tight

                    line-clamp-2
                    break-words
                ">
                    {facility.facility_name}
                </h2>

                <p className="
                    text-xs
                    text-gray-500
                    mt-1
                    truncate
                ">
                    {facility.city}, {facility.state}
                </p>

            </div>

            {/* BOTTOM */}

            <div className="mt-3">

                <div className="
                    flex
                    items-end
                    justify-between
                ">

                    <div>

                        <p className="
                            text-[10px]
                            uppercase
                            tracking-wide
                            text-gray-400
                        ">
                            Current Vehicles
                        </p>

                        <p className="
                            text-3xl
                            font-bold
                            text-blue-600
                            leading-none
                        ">
                            {facility.current_vehicles || 0}
                        </p>

                    </div>

                    <div className="
    text-right
    text-xs
    text-gray-500
    space-y-1
">
                        <p>
                            <span className="font-bold">
                                Capacity: {facility.capacity ?? 0}
                            </span>
                        </p>

                        <p>
                            Check In: {facility.total_checkins_today || 0}
                        </p>

                        <p>
                            Check Out: {facility.total_checkouts_today || 0}
                        </p>
                    </div>

                </div>

            </div>

        </motion.div>
    );
}